import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

import { useState, useEffect } from 'react';
import UnitDisplay from './UnitDisplay';
import { Modal } from 'react-bootstrap';

import api_url from '../../config/api_url';
import { authHeaders } from '../../utils/authHeaders';


const UnitList = () => {

    const [units, setUnits] = useState([{name: ""}]);
    const [param, setParam] = useState("");
    const [show, setShow] = useState(false);
    const [currentIdx, setCurrentIdx] = useState(0);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);



    useEffect(() => {
        let isSubscribed = true;

        // declare the async data fetching function
        const fetchData = async () => {
          // get the data from the api
          

          const fetchUrl = api_url + "/api/unit" + (param.length>0? "/" + param : "");
          const data = await fetch(fetchUrl);
          const json = await data.json();
          console.log(json);

          //const data = [{name: "abc", id: 1, price:"12dkk",}, {name: "efg", id: 2, price:"12dkk"}, {name:param, id: 3, price:"14dkk"} ]
          // convert the data to json
          //const json = await response.json();
        
          // set state with the result if `isSubscribed` is true
          if (isSubscribed) {
            setUnits(json);
          }
        }
      
        // call the function
        fetchData()
          // make sure to catch any error
          .catch(console.error);;
      
        // cancel any future `setData`
        return () => isSubscribed = false;
      }, [param])


    const removeHandler = (idx) => {
        handleShow();
        setCurrentIdx(idx);
    }

    const editHandler = async (idx, obj) => {
        if(obj.id !== undefined) {
            const response = await fetch(api_url + '/api/unit', {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    ...authHeaders()
                },
                body: JSON.stringify({unit: obj})
              });

        } else {

            const response = await fetch(api_url + '/api/unit', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    ...authHeaders()
                },
                body: JSON.stringify({unit: obj})
              });
              let json = await response.json();
              obj = json;
        }
        

        setUnits([
            ...units.slice(0, idx),
            obj,
            ...units.slice(idx +1 )
        ]);


    }

    const deleteUnit = async () => {
        handleClose();

        const response = await fetch(api_url + '/api/unit', {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...authHeaders()
            },
            body: JSON.stringify({id: units[currentIdx].id})
          });

        


        setUnits([
            ...units.slice(0, currentIdx),
            ...units.slice(currentIdx + 1)
          ]);
    }

    const addNewUnit = () => {
        setUnits([...units, {name:""}])
    }


    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Slet Enhed</Modal.Title>
                </Modal.Header>
                <Modal.Body>Er du sikker på du vil slette enhed {units.length > 0 ? units[currentIdx].name : "ERROR"}?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Tilbage
                    </Button>
                    <Button variant="primary" onClick={deleteUnit}>
                        Slet
                    </Button>
                </Modal.Footer>
            </Modal>


        <Row>
            <Col xs={10}>
                <Button onClick={addNewUnit}>Tilføj en ny enhed</Button>
            </Col>
        </Row>
            {units.length > 0 ? units.map((unit, i) => <UnitDisplay obj={unit} key={i} index={i} deleteFunction={removeHandler} editFunction={editHandler} />) : null}
        </>
        
    );

}

export default UnitList;